// src/components/Footer.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
// MODIFICACIÓN 1: Importar Link de react-router-dom
import { Link } from 'react-router-dom';

const Footer = () => {
    // Define tus rutas aquí para mantenerlas consistentes
    const termsPath = "/terms-and-conditions";
    const privacyPath = "/privacy-policy"; // Asume que tendrás esta ruta también
    const cookiesPath = "/cookie-policy"; // Asume que tendrás esta ruta también
    // const disclaimerPath = "/disclaimer"; // Si tienes una página de disclaimer

    return (
        <footer className="landing-footer py-5">
            <Container className="px-5">
                <Row>
                    <Col md={3}>
                        <h4 className="footer-logo">MyFit Menu AI</h4>
                        <p className="footer-description">Analyze what's really in your food</p>
                    </Col>
                    <Col md={3}>
                        <h5 className="footer-links-title">Product</h5>
                        <ul className="list-unstyled footer-links">
                            {/* Conserva Link o <a> según si son rutas internas o externas */}
                            <li><Link to="/#features" className="text-decoration-none">Features</Link></li> {/* Ejemplo si features es una sección en la landing */}
                            <li><Link to="/#how-it-works" className="text-decoration-none">How It Works</Link></li> {/* Ejemplo */}
                            <li><a href="#" className="text-decoration-none">Testimonials</a></li> {/* Si es externo o sección */}
                            <li><Link to="/pricing" className="text-decoration-none">Pricing</Link></li>
                        </ul>
                    </Col>
                    <Col md={3}>
                        <h5 className="footer-links-title">Company</h5>
                        <ul className="list-unstyled footer-links">
                            <li><Link to="/about" className="text-decoration-none">About Us</Link></li>
                            <li><a href="#" className="text-decoration-none">Careers</a></li> {/* Cambiar si es interno */}
                            <li><a href="#" className="text-decoration-none">Press</a></li> {/* Cambiar si es interno */}
                            <li><Link to="/contact" className="text-decoration-none">Contact</Link></li>
                        </ul>
                    </Col>
                    <Col md={3}>
                        <h5 className="footer-links-title">Resources</h5>
                        <ul className="list-unstyled footer-links">
                            <li><a href="#" className="text-decoration-none">Blog</a></li> {/* Cambiar si es interno */}
                            <li><a href="#" className="text-decoration-none">Help Center</a></li> {/* Cambiar si es interno */}
                            <li><a href="#" className="text-decoration-none">Food Database</a></li> {/* Cambiar si es interno */}
                            <li><a href="#" className="text-decoration-none">API</a></li> {/* Cambiar si es interno */}
                        </ul>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col md={3}>
                        <h5>Legal</h5>
                        <ul className="list-unstyled">
                            {/* MODIFICACIÓN 2: Cambiar href por 'to' y usar Link */}
                            <li><Link to={termsPath} className="text-decoration-none">Terms of Service</Link></li>
                            <li><Link to={privacyPath} className="text-decoration-none">Privacy Policy</Link></li>
                            <li><Link to={cookiesPath} className="text-decoration-none">Cookies</Link></li>
                            {/* <li><Link to={disclaimerPath} className="text-decoration-none">Disclaimer</Link></li> */}
                        </ul>
                    </Col>
                    <Col md={{ span: 3, offset: 6 }} className="text-end">
                        <ul className="list-inline social-icons">
                            <li className="list-inline-item">
                                <a href="#" aria-label="Facebook"> {/* Mantén <a> para enlaces externos */}
                                    <FaFacebook size={24} />
                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="#" aria-label="Twitter">
                                    <FaTwitter size={24} />
                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="#" aria-label="Instagram">
                                    <FaInstagram size={24} />
                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href="#" aria-label="LinkedIn">
                                    <FaLinkedin size={24} />
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <div className="text-center mt-4 border-top pt-4">
                    <small>© {new Date().getFullYear()} MyFit Menu AI. All rights reserved.</small>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;